export * from './resource-carousel.module';

export * from './resource-carousel.component';
export * from './resource-carousel-slide.directive';
